module.exports = ".logout-btn {\n  cursor: pointer;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  outline: none;\n  border: none;\n  color: #7d939e;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/logout/logout.component.scss
// module id = ./src/app/header/logout/logout.component.scss
// module chunks = main